import { useTranslation } from 'react-i18next';
import { AnimatedSection } from '../../../components/AnimatedSection';

export default function CaseStudiesHero() {
  const { t } = useTranslation();

  const stats = [
    { value: '200+', label: t('cs_stat1_label') },
    { value: '15+', label: t('cs_stat2_label') },
    { value: '100%', label: t('cs_stat3_label') },
  ];

  return (
    <section className="relative pt-32 pb-20 bg-slate-950 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/fa24dfec86f9046169d04456c7fdbf66.jpg"
          alt=""
          className="w-full h-full object-cover object-top opacity-15"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-950/80 to-slate-950"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 text-center">
        <AnimatedSection animation="fade-in">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-cyan-500/10 border border-cyan-500/30 rounded-full mb-6">
            <i className="ri-trophy-line text-cyan-400 text-sm"></i>
            <span className="text-cyan-400 text-sm font-medium">{t('cs_badge')}</span>
          </div>
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
            {t('cs_hero_title1')}<br />
            <span className="text-cyan-400">{t('cs_hero_title2')}</span>
          </h1>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto mb-14">
            {t('cs_hero_desc')}
          </p>
        </AnimatedSection>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
          {stats.map((stat, i) => (
            <AnimatedSection key={stat.label} animation="scale-up" delay={0.1 + i * 0.1}>
              <div className="bg-white/5 border border-white/10 rounded-xl p-6">
                <div className="text-4xl font-bold text-cyan-400 mb-2">{stat.value}</div>
                <div className="text-slate-400 text-sm">{stat.label}</div>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
}
